/*
 * Bloc « produit proposé » du panier (snippets/cart-upsell-product.liquid).
 *
 * Les écouteurs sont délégués sur document : CartDrawer.renderContents
 * réinjecte le drawer via innerHTML, ce qui n'exécute pas les scripts et
 * détacherait des écouteurs posés directement sur les éléments.
 */
(function () {
  const SELECTORS = {
    component: '.cart-upsell-component',
    button: '.cart-upsell-btn',
    radio: 'input[name="cart-upsell-variant"]',
    value: '.cart-upsell-dropdown__value',
  };

  document.addEventListener('change', (event) => {
    const radio = event.target.closest(SELECTORS.radio);
    if (!radio) return;

    const component = radio.closest(SELECTORS.component);
    if (!component) return;

    const button = component.querySelector(SELECTORS.button);
    const value = component.querySelector(SELECTORS.value);

    if (button) button.dataset.variantId = radio.value;
    if (value) value.textContent = radio.dataset.variantTitle || '';

    if (typeof FilterDropdown !== 'undefined') FilterDropdown.closeAll();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTORS.button);
    if (!button || button.disabled) return;

    event.preventDefault();
    addUpsellToCart(button);
  });

  function addUpsellToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const drawer = document.querySelector('cart-drawer');
    const label = button.querySelector('span');
    const spinner = button.querySelector('.loading-overlay__spinner');

    setLoading(button, label, spinner, true);

    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };

    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          throw new Error(parsedState.description || parsedState.message);
        }

        if (drawer && parsedState.sections) {
          drawer.renderContents(parsedState);
          return;
        }

        window.location.reload();
      })
      .catch((error) => {
        console.error('cart-upsell:', error);
        setLoading(button, label, spinner, false);
      });
  }

  function setLoading(button, label, spinner, isLoading) {
    button.disabled = isLoading;
    if (label) label.classList.toggle('d-none', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }
})();
